define('views/modules/member/supervisors/new-messages',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'moment',
    // views
    'views/parts/form/button',
    'views/modules/conversation/message/new-message-list',
    'views/modules/conversation/message/new-message-list-item',
    // models & collections
    'collections/conversation/messages',
    'collections/conversation/conversations',
    // templates
    'text!templates/modules/member/supervisors/new-messages.html',
], function(
    // Libs
    _, Backbone, Mustache, U, moment,
    // views
    VButton,
    VNewMessageList,
    VNewMessageListItem,
    // models & collections
    CMessages,
    CConversations,
    // templates
    TNewSupervisorMessages
) {

    var VNewSupervisorMessages = Backbone.View.extend({
        template: TNewSupervisorMessages,

        regions: {
            button: ".btn-clear-messages",
            list: ".new-message-list",
        },

        initialize: function(opt) {
            opt = opt || {};

            this.setUrl('conversation', '#/' + opt.url);

            _.extend(this, { profile: this.model });

            var collection = this.collection = new CMessages(),
                conversations = this.conversations = new CConversations(),
                view = this.view = {
                    list: new VNewMessageList({
                        collection: collection,
                        item: VNewMessageListItem,
                        async: false,
                        conversations: this.conversations,
                        title: 'New messages',
                    }),
                    button: new VButton({
                        label: "Clear all messages",
                        callback: this.onClearAllMessages,
                        context: this,
                        tcClass: false,
                        icon: false,
                        class: 'btn-rounded',
                    }),
                };

            this.listenTo(conversations, { 'sync': this.onConversationsSync })
                .listenTo(collection, { 'message:click': this.onMessageClick });
        },

        render: function() {

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.list, zone.$list)
                .assign(view.button, zone.$button);

            this.conversations.getFirstPage({ unread: true });

            return this;
        },

        getCollection: function() {
            return this.collection;
        },

        getConversations: function() {
            return this.conversations;
        },

        toggle: function(val) {
            if (!_.isUndefined(val)) val = !val;
            this.$el.toggleClass('hidden', val);
        },

        //////////////
        // events //
        ////////////

        onConversationsSync: function(collection) {
            this.toggle(Boolean(collection.length));
            this.collection.setUsers(collection.getUsers())
                .reset(collection.getAllMessages());
        },

        onClearAllMessages: function() {
            var conversations = this.conversations;
            conversations.each(function(model) {
                model.markAsRead({});
            }, this);
            conversations.reset();
        },

        onMessageClick: function(model) {
            var conversationId = model.get('conversation');
            Backbone.history.navigate(
                Mustache.render(this.url.conversation + '{{{conversationId}}}/', {
                    userId: this.profile.id,
                    conversationId: conversationId
                }));
        },

    });

    return VNewSupervisorMessages;

});

